import { ModelPromoted } from "api"
import { trackHpCubesClicks } from "common/analytics"
import NextImage from "common/bit/NextImage"
import NextLink from "common/bit/NextLink"
import MoreDetailsButton from "reusable/MoreDetailsButton"
import styled from "styled-components"
import { StyledCol, StyledRow, TypographyRtl } from "theme/shared"

const StyledWrapper = styled.div`
  width: 100%;
  border-radius: 3px;
  border: 1px solid ${(p) => p.theme.colors.borderGrey};
  padding: 20px;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 470px;
  }
`
const StyledImageContainer = styled.div`
  aspect-ratio: 320/100;
  width: 100%;
`
const StyledTitle = styled(TypographyRtl).attrs({
  variant: "h2",
})`
  font-weight: "normal";
  margin-top: 10px;
  margin-bottom: 4px;
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: center;
  }
`
const StyledText = styled(TypographyRtl).attrs({
  variant: "h3",
})`
  font-weight: "300";
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: center;
  }
`
const StyledFlexRow = styled(StyledRow)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 100%;
    gap: 20px;
    justify-content: center;
  }
`
type ToolsCardProps = {
  toolsData: ModelPromoted
}

const ToolsCard = ({ toolsData }: ToolsCardProps) => {
  return (
    <StyledWrapper>
      <StyledImageContainer>
        <NextImage image={toolsData.image} role="presentation" ariaHidden />
      </StyledImageContainer>
      <StyledCol $notCenter $fullWidth>
        <StyledTitle>{toolsData.name}</StyledTitle>
      </StyledCol>
      <StyledFlexRow>
        <StyledText>{toolsData.description}</StyledText>
        <NextLink href={toolsData.link} onClick={() => trackHpCubesClicks()}>
          <MoreDetailsButton />
        </NextLink>
      </StyledFlexRow>
    </StyledWrapper>
  )
}

export default ToolsCard
